<template>
  <div class="user-edit">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="editForm" :model="userModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="姓名" prop="displayName">
            <Input v-model="userModel.displayName" placeholder="输入姓名" />
          </FormItem>
          <FormItem label="登录用户名" prop="loginName">
            <Input v-model="userModel.loginName" placeholder="输入登录用户名" />
          </FormItem>
          <FormItem label="原登录密码" prop="oldPassword">
            <Input v-model="userModel.oldPassword" type="password" placeholder="输入原登录密码" />
          </FormItem>
          <FormItem label="登录密码" prop="password">
            <Input v-model="userModel.password" type="password" placeholder="输入登录密码" />
          </FormItem>
          <FormItem label="重复登录密码" prop="rePassword">
            <Input v-model="userModel.rePassword" type="password" placeholder="重复输入登录密码" />
          </FormItem>
          <!-- <FormItem label="性别" prop="gender">
            <RadioGroup v-model="userModel.gender">
              <Radio :label="1" border>男</Radio>
              <Radio :label="2" border>女</Radio>
            </RadioGroup>
          </FormItem> -->
          <FormItem label="手机号" prop="mobile">
            <Input v-model="userModel.mobile" placeholder="输入手机号" />
          </FormItem>
          <!-- <FormItem label="邮箱" prop="email">
            <Input v-model="userModel.email" placeholder="输入E-mail" />
          </FormItem> -->
          <FormItem label="用户类型" prop="type" @on-change="changeUserType">
            <Select v-model="userModel.type" filterable>
              <Option v-for="(tp,idx) in userTypesAvailable" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="角色" prop="roleId">
            <Select v-model="userModel.roleId" filterable>
              <Option v-for="(tp,idx) in roles" :key="idx" :value="parseInt(tp.tid)">{{tp.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态" prop="enabled">
            <i-switch v-model="userModel.enabled" size="large">
              <span slot="open">启用</span>
              <span slot="close">禁用</span>
            </i-switch>
          </FormItem>
          <FormItem label="CA序列号" prop="certSn">
            <Input v-model="userModel.certSn" placeholder="输入CA序列号" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
        <!-- <div class="avatar-section">
          <div class="student-avatar">
            <Icon type="md-person" :size="120" color="#ccc" />
          </div>
          <div class="padding-top-20"></div>
          <div class="avatar-upload">
            <Upload action="//jsonplaceholder.typicode.com/posts/">
              <Button icon="ios-cloud-upload-outline">上传头像</Button>
            </Upload>
          </div>
        </div> -->
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'user-edit',
  props: {
  },
  data () {
    const validateRepassword = (rule, value, callback) => {
      if (this.userModel.password && value !== this.userModel.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      loading: false,
      userModel: {
        id: null,
        displayName: null,
        oldPassword: null,
        oldPasswordMd5: null,
        password: null,
        passwordMd5: null,
        rePassword: null,
        gender: 1,
        loginName: null,
        enabled: true,
        mobile: null,
        email: null,
        type: null,
        certSn: null,
        roleId: null
      },
      modelValidate: {
        displayName: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        loginName: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        type: [
          { type: 'number', required: true, message: '请选择用户类型', trigger: 'blur' }
        ],
        rePassword: [
          { validator: validateRepassword, trigger: 'blur' }
        ]
      },
      roles: []
    }
  },
  watch: {
  },
  computed: {
    userTypesAvailable () {
      let typs = this.$common.getEnumSelect(this.$common.userType)
      if (this.checkRolePermitted(['总监管人','管理员'])) {
        return typs
      }
      if (typs && typs instanceof Array) {
        typs = typs.filter((t) => {
          return parseInt(t.key) === this.$store.getters.userInfo.type
        })
        return typs
      } else {
        return typs
      }
    }
  },
  mounted () {
    this.initRoles()
    if (this.$route.params.user) {
      this.userModel = this.$route.params.user
    } else {
      this.userModel = {
        id: null,
        displayName: null,
        oldPassword: null,
        oldPasswordMd5: null,
        password: null,
        passwordMd5: null,
        rePassword: null,
        gender: 1,
        loginName: null,
        enabled: true,
        mobile: null,
        email: null,
        type: null,
        certSn: null,
        roleId: null
      }
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async initRoles () {
      let res = await this.$Api.Role.listRoles({
        name: null,
        type: null,
        isReserved: null
      }, 1, -1).catch(err => {
        console.log(err)
        this.$Message.error(err.message)
      })
      this.roles = res.data
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          if (this.userModel.oldPassword) {
            this.userModel.oldPasswordMd5 = this.$md5(this.userModel.oldPassword)
          }
          if (this.userModel.password) {
            this.userModel.passwordMd5 = this.$md5(this.userModel.password)
          }
          await Api.Auth(this).updateUser(this.userModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    },
    changeUserType (cur) {
      if (cur && this.roles && this.roles instanceof Array) {
        this.roles.forEach((r) => {
          if (r.type !== cur) {
            r.disabled = true
          } else {
            r.disabled = false
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
</style>
